module.exports = __webpack_public_path__ + "1850d5bf343445812a8ffaf167ffb47a.svg";